/** Absolute max applied to dashboard change percentages when clamping is requested. */
export const DASHBOARD_CHANGE_FALLBACK_MAX = 1;

export type ResolveDashboardChangePercentOptions = {
  /**
   * When true, `0` is treated like missing data and normalized to `0`.
   */
  treatZeroAsMissing?: boolean;
  /**
   * When set (e.g. `1`), finite API values are clamped to `[-clampAbsMax, clampAbsMax]`.
   */
  clampAbsMax?: number;
};

function clampSignedPercent(value: number, maxAbs: number): number {
  if (!Number.isFinite(value) || maxAbs < 0) {
    return value;
  }
  if (value >= 0) {
    return Math.min(value, maxAbs);
  }
  return Math.max(value, -maxAbs);
}

/**
 * Uses API value when it is a finite number.
 * Otherwise returns `0`.
 */
export function resolveDashboardChangePercent(
  fromApi: number | null | undefined,
  _seed: string | number,
  options?: ResolveDashboardChangePercentOptions
): number {
  const treatZero = options?.treatZeroAsMissing ?? false;
  const clampMax = options?.clampAbsMax;

  if (typeof fromApi === "number" && Number.isFinite(fromApi)) {
    if (treatZero && fromApi === 0) {
      return 0;
    }

    let value = fromApi;
    if (clampMax !== undefined) {
      value = clampSignedPercent(value, clampMax);
    }
    return value;
  }

  return 0;
}
